import { render } from "./views/AuthorizationAvn.html?vue&type=template&id=f293805c&external"
import script from "./AuthorizationAvn.vue?vue&type=script&lang=js"
export * from "./AuthorizationAvn.vue?vue&type=script&lang=js"

import "./AuthorizationAvn.vue?vue&type=style&index=0&id=f293805c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__